<template>
  <div id="k0008_container" style="border: 0px solid red; height:100%">
    <div id="ulAiWidget" style="margin-top:10px"></div>
  </div>
</template>
<script>

let url = require('@/../config/sysConfig')

export default {
  data() {
    return {
      userInfo: [],
    };
  },
  methods: {
    destroyChatbotScript() {
      const container = document.getElementById('k0008_container');
      if (container) {
        container.innerHTML = ''; // 清空容器内的内容
        // 可选：移除 k0008_container 元素本身
        container.parentNode.removeChild(container);
      }
    },
    removeScriptElement() {
      // 移除动态创建的 script 元素
      if (this.scriptElement && this.scriptElement.parentNode) {
        this.scriptElement.parentNode.removeChild(this.scriptElement);
        this.scriptElement = null; // 释放引用
      }
    }
  },
  created() {

  },
  beforeDestroy() {
    this.destroyChatbotScript();
    this.removeScriptElement();
  },
  mounted() {
    const script = document.createElement('script');
    script.id = 'k0008_script' 
    script.type = "text/javascript";
    script.innerHTML = "";
    var scriptText = "";
    scriptText = "(function (c, n, s) {";
    scriptText = scriptText + "if (c[n] === void 0) {c['ULObject'] = n; ";
    scriptText = scriptText + "		c[n] = c[n] || function () {(c[n].q = c[n].q || []).push(arguments)}; ";
    scriptText = scriptText + "		c[n].l = 1 * new Date();var e = document.createElement('script'); ";
    scriptText = scriptText + "		e.async = 1;e.src = s + '/chatbot.js'; ";
    scriptText = scriptText + "		var t = document.getElementsByTagName('script')[0];t.parentNode.insertBefore(e, t);} ";
    scriptText = scriptText + "})(window, 'ul_widget', 'https://support-widget.userlocal.jp'); ";
    scriptText = scriptText + "ul_widget('init', { 'id': '302ae48f41f91e4de143', 'site_in': true, 'mode_spa': true, 'lg_id': '', 'target_id':'ulAiWidget'});";
    scriptText = scriptText + "";
    script.innerHTML = scriptText;
    const container = document.getElementById('k0008_container');
    container.prepend(script);
  }
};
</script>
<style scope>

</style>


// WEBPACK FOOTER //
// src/module/page/k_0008.vue